<template>

  <div class='small-footer'>
    <div class='baiyi-main-know flex space-between fwrap container'>
      <ul class='baiyi-main-know-content flex fwrap xm7 xl12'>
        <li>
          <h3 class='baiyi-main-know-title'>
            走进百驿
          </h3>
          <ul class='baiyi-main-know-subcontent'>
            <li>
              <a :href="this.baseURL+'about.html'">百驿简介</a>
            </li>
            <li>
              <a :href="this.baseURL+'about.html'">愿景使命</a>
            </li>
            <li>
              <a :href="this.baseURL+'about.html'">理念原则</a>
            </li>
            <li>
              <a :href="this.baseURL+'about.html'">诚聘英才</a>
            </li>
            <li>
              <a :href="this.baseURL+'about.html'">联系我们</a>
            </li>
          </ul>
        </li>

        <li>
          <h3 class='baiyi-main-know-title'>
            产品服务
          </h3>
          <ul class='baiyi-main-know-subcontent'>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">网络化互联互通</a>
            </li>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">智能化互联互通</a>
            </li>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">数字化互联互通</a>
            </li>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">生态化互联互通</a>
            </li>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">商贸化互联互通</a>
            </li>
            <li>
              <a :href="this.baseURL+'baiyi_product.html'">优势功能</a>
            </li>

          </ul>
        </li>


        <li>
          <h3 class='baiyi-main-know-title'>
            行业资讯
          </h3>
          <ul class='baiyi-main-know-subcontent'>
            <li>
              <a :href="this.baseURL+'policy.html'">物流头条</a>
            </li>
            <li>
              <a :href="this.baseURL+'policy.html'">最新动态</a>
            </li>
            <li>
              <a :href="this.baseURL+'policy.html'">聚焦观点</a>
            </li>

          </ul>
        </li>

        <li>
          <h3 class='baiyi-main-know-title'>
            百驿学院
          </h3>
          <ul class='baiyi-main-know-subcontent'>
            <li>
              <a :href="this.baseURL+'byCollege.html'">政策解读</a>
            </li>
            <li>
              <a :href="this.baseURL+'byCollege.html'">百驿访谈</a>
            </li>
            <li>
              <a :href="this.baseURL+'byCollege.html'">直播课堂</a>
            </li>
            <li>
              <a :href="this.baseURL+'byCollege.html'">物流智库</a>
            </li>


          </ul>
        </li>

        <li>
          <h3 class='baiyi-main-know-title'>
            加入百驿
          </h3>
          <ul class='baiyi-main-know-subcontent'>
            <li>
              <a :href="this.baseURL+'join.html'">入图须知</a>
            </li>
            <li>
              <a :href="this.baseURL+'join.html#/mall/shopPage'">入网须知</a>
            </li>
            <li>
              <a :href="this.baseURL+'join.html'">入股须知</a>
            </li>
            <li>
              <a :href="this.baseURL+'join.html'">申请加入</a>
            </li>
          </ul>
        </li>

      </ul>
      <div class='baiyi-contact-cell flex xm5 xl12'>
        <div class='baiyi-wechat flex fCenter itemCenter'>
          <img src='../../assets/img/footer/gzh.png' ref="appStore"  class='gzh' />
          <img src='../../assets/img/footer/xz.png' ref="weinXin" class='xz' />
        </div>
        <div class='baiyi-phone1'>
          <h3>010-58565158</h3>
          <p>24小时咨询电话</p>
          <span class='icon-weixin footer-weixin'  @mouseover="weiXinComeIn"></span>
          <img src='../../assets/img/footer/appStore.png'  @mouseover="appStoreComeIn" class='appStore' alt='' />
        </div>

      </div>

    </div>

    <p class='container copyright'>
      百驿物联股份有限公司 <a href='http://www.miitbeian.gov.cn'>京ICP备18038634号-1</a>    &nbsp&nbsp&nbsp&nbsp 友情链接： <a href='http://www.linangroup.cn/' target='_blank'>林安物流园</a> <a href='http://www.cnzh56.com/' target='_blank'>志宏集团</a> <a href='http://www.xiangjiangwuliu.com/' target='_blank'>吉林香江物流园</a> <a href='http://www.apjc56.com/' target='_blank'>聚成国际物流园</a> <a href='http://www.quehua.net/' target='_blank'>山东鹊华集团</a> <a href='http://www.hengdong.chinawutong.com/' target='_blank'>衡东综合物流园</a> <a href='http://www.qdbf56.cn/' target='_blank'>宝丰集团</a> <a href='http://www.hengteng56.cn/' target='_blank'>恒腾物流</a>
    </p>


  </div>

</template>

<script>
    export default {
      name: "Footer",
      data(){
          return{
            baseURL: 'https://www.b100y.com/'
          }
      },

      methods: {
        weiXinComeIn(){
          const weiXin = this.$refs.weinXin
          weiXin.style.display='block'
          const appStore = this.$refs.appStore
          appStore.style.display='none'
        },
        appStoreComeIn(){
          const weiXin = this.$refs.weinXin
          weiXin.style.display='none'
          const appStore = this.$refs.appStore
          appStore.style.display='block'
        }
      }
    }
</script>

<style scoped>
@import "../../assets/footer/common.css";
@import "../../assets/footer/reset.css";
@import "../../assets/footer/pintuer.css";


</style>



// WEBPACK FOOTER //
// src/layout/components/Footer.vue